/**
 * Created by jiafengf.wang on 2020/5/25.
 * 通用API--请求发送
 */
import qs from 'qs'; // eslint-disable-next-line no-unused-vars

var noop = function noop() {};

var RequestTypeMap = {
  'text': 'text/plain; charset=UTF-8',
  'json': 'application/json;charset=utf-8',
  'form': 'application/x-www-form-urlencoded;charset=utf-8'
};

var converter = function converter(type) {
  var plain = function plain(text) {
    return text;
  };

  return {
    json: JSON.stringify,
    form: qs.stringify
  }[type] || plain;
};

var typeMap = function typeMap(type) {
  return {
    text: 'text/plain; charset=UTF-8',
    json: 'application/json; charset=UTF-8',
    form: 'application/x-www-form-urlencoded; charset=UTF-8'
  }[type] || ['*/'] + ['*']; // 避免被压缩
};

var support = {
  blob: typeof FileReader === 'function' && typeof Blob === 'function' && function () {
    try {
      Blob();
      return true;
    } catch (e) {
      return false;
    }
  }(),
  formData: typeof FormData === 'function'
};
/**
 * request 封装
 * @param {*} options 配置参数
| 参数名称       | 说明                                  | 默认值  | 特性   |
|:--------------|:-------------------------------------|:-------|:-------|
| url           | 接口地址                              |        |        |
| param         | 请求参数                              |        |        |
| method        | 请求方式                              | GET    |        |
| timeout       | 超时时间                              |        |        |
| headers       | 头部                                  |        |        |
| serialize     | 返回结果是否序列化                      | true   |        |
|withCredentials| 跨域请求是否提供凭据信息                 | true   |        |
 */

var request = function request() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!(typeof options.url === 'string' && options.url.length > 0)) {
    throw Error('url参数非法');
  } // 默认get方法请求，默认将配置参数转为大写便于后续使用


  options.method = (options.method || 'GET').toUpperCase();
  options.headers = options.headers || {};
  options.credentials = options.credentials || {};
  options.serialize = typeof options.serialize === 'boolean' ? options.serialize : true;
  options.withCredentials = typeof options.withCredentials === 'boolean' ? options.withCredentials : true;
  options.requestType = options.requestType || 'json';
  options.responseType = options.responseType || 'json';

  if (options.method === 'POST') {
    options.headers = Object.assign({
      'Content-Type': typeMap(options.requestType),
      'Accept': typeMap(options.responseType)
    }, options.headers);
    options.data = converter(options.requestType)(options.body);
  } else {
    options.data = null;
    var qsQuery = qs.stringify(options.body);

    if (qsQuery && qsQuery.length > 0) {
      options.url = "".concat(options.url, "?").concat(qsQuery);
    }
  }

  var xhr = new XMLHttpRequest();
  var promise = new Promise(function (resolve, reject) {
    xhr.open(options.method, options.url, true);
    xhr.timeout = options.timeout;

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob';
    }

    xhr.withCredentials = options.withCredentials; // 设置请求头
    // eslint-disable-next-line no-restricted-syntax

    for (var key in options.headers) {
      if (Object.prototype.hasOwnProperty.call(options.headers, key)) {
        xhr.setRequestHeader(key, options.headers[key]);
      }
    } // 注册xhr对象事件
    // xhr.onprogress = options.onprogress;
    // xhr.upload.onprogress = options.onuploadprogress;
    // xhr.responseType = options.responseType;


    xhr.onabort = function (message) {
      reject(new Error('请求取消', message));
    };

    xhr.ontimeout = function () {
      reject(new Error('请求超时', xhr));
    };

    xhr.onerror = function () {
      reject(new Error('请求失败', xhr));
    };

    xhr.onloadend = function () {
      if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
        var serialized = xhr;

        if (options.serialize) {
          try {
            serialized = JSON.parse(xhr.response);
          } catch (error) {
            reject(new Error(error));
          }
        }

        resolve(serialized);
      } else {
        reject(new Error(xhr));
      }
    };

    try {
      xhr.send(options.data);
    } catch (e) {
      reject(new Error(e));
    }
  }); // abort取消请求

  promise.cancel = function (message) {
    xhr.abort(message);
  };

  return promise;
};

try {
  if (Ext) {
    Ext.utils.fetch = request;
  }
} catch (e) {}

export default request;